import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/singles.js";

let component = Vue.component("singles", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['opt','jsonval', 'urlValue'],
      data() {
        return {
          templateId:templateId,
          singlesel: '0',
          name: this.jsonval.anychoice,
          isLabel:false,
          isempty:true,
          istempty: 'ok-select -state-empty',
          isntempty: 'ok-select'
        }
      },
      computed:{
        labelclasstrue(){ return this.templateId>35 ? 'ok-form-label -state-active' : 'col-md-12 ok-label-static'},
        labelclassfalse(){ return this.templateId>35 ? 'ok-form-label' : 'col-md-12 ok-label-static -state-empty'},
      },
      methods: {
        ch(index) {
          this.singlesel=this.opt.options[index].id;
          this.name=this.opt.options[index].value;
          this.isLabel=true;
        },
        defaultvalue() {
          this.singlesel=0;
          this.name=this.jsonval.anychoice;
          this.isLabel=false;
        },
      },
      watch: {
        singlesel() {
          if (this.singlesel > 0) {
            this.isempty=false;
          } else {
            this.isempty=true;
          }
        },
        'urlValue': function() {
          if (this.urlValue.indexOf('group_id=') > 0) {
            let text2 = this.urlValue.substring(this.urlValue.indexOf('findtext='))
            let text = text2.substring(text2.indexOf(`${this.opt.name}`))
            let first = text2.substring(text2.indexOf(`${this.opt.name}`)).indexOf('=')
            let last = null
            if (text2.substring(text2.indexOf(`${this.opt.name}`)).indexOf('&') === -1) {
              last =  text2.substring(text2.indexOf(`${this.opt.name}`)).length
            } else {
              last = text2.substring(text2.indexOf(`${this.opt.name}`)).indexOf('&')
            }
            let res = parseInt(text.substring(first + 1, last))
            this.singlesel = res
            for (let i = 0; i < this.opt.options.length; i++) {
              if (this.opt.options[i].id === res) {
                this.name = this.opt.options[i].value
                this.isLabel = true
                this.isempty = false
              }
            }
          }
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/singles.js